module.exports = __webpack_public_path__ + "media/footer/apple-store-13a46ee5.svg";